try {
    window.popper    = require('popper.js');
    window.jQuery    = window.$ = require('jquery');
    window.bootstrap = require('bootstrap');
    window.feather   = require('feather-icons');
    window.leaflet   = require('leaflet');
    window.AOS       = require('aos');

    feather.replace();
    AOS.init();
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })



} catch (e) {
    console.log(e);
}

/**
 * Shrink navbar
 */
$(window).on('scroll', function () {
    if ($(window).scrollTop() >= 84) {
        $('.navbar').addClass(['navbar-shrink','shadow-3']);
        $("#scrollTop").addClass(['showScroll']);
    } else {
        $('.navbar').removeClass(['navbar-shrink','shadow-3']);
        $("#scrollTop").removeClass(['showScroll']);
    }
});

/**
 * Scroll To Top (button on the right bottom side).
 */
$("#scrollTop").find('.btn').click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");return false;
});

$("a#printPage").click(function () {
    window.print();
    return false;
});